// This file contains the copy for the sales page

// HERO
export const MainHeaderA = 'The Fastest & Easiest way to Monetize your Passion'
export const MainHeaderB = 'The Monetization toolkit for scaling your passion'
export const NavbarCtaText = "Join 1000's already earning 👉"

export const MainDescriptionA = 'The partner for growth to the world’s best creators and experts.'
// export const MainDescriptionB = "Memberships, 1:1 coaching, paid messages, premium communities & one off payments, we've built tools to empower your business."
// export const MainDescriptionB = "Join the world's best creators and coaches in building a sustainable, recurring revenue stream effortlessly."
// export const MainDescriptionB = "The best parts of Kajabi, Patreon, Circle, Passes, and Teachable in one simple, easy-to-use platform."
// export const MainDescriptionB = "Now with courses. One place to build, manage, and grow your business."
// export const MainDescriptionB = "Now with digital products & courses. One place to build, manage, and grow your online business."
export const MainDescriptionB = "WithMe is the all-in-one hub for creators and experts — with every tool to launch coaching, courses, and subscriptions unlocked from day one."


// SUPPORT
export const SupportHeader = "SUPPORTING 1000'S OF CREATORS & EXPERTS FROM AROUND THE WORLD"
export const SupportDescription = "Join thousands of creators and experts who are building businesses using WithMe. Take back control of your income and time, with no cap to your earnings. Be paid out the same day, and achieve a stress free life outside of the algorithm or paid partnership treadmill!"

// export const SupportDescription = "Join thousands of creators and experts of all different niches from across the globe who are thriving with our platform. Discover inspiring stories of success and innovation as our users leverage powerful tools to build, monetize, and grow their audiences. "


// FEATURE
// export const FeatureHeader = 

export const FeatureDescription = "Enhance your hub with our engagement and monetization tools. Every tool designed to boost interaction and revenue. Empower your users to connect and grow in meaningful ways."

    // MEMBERSHIPS
    export const MembershipTitle = "Exclusive content? Sell memberships"
    export const MembershipDescription = "Enable users to purchase memberships for special access to exclusive content, enhancing their engagement and loyalty. We support 6 forms of content. Images, videos, guides (pdfs), text, audio & live streams all make up the post format."
    export const MembershipKeypoints = ['Mulitple Tiering Settings', 'Flexible Trial Options', 'Customisable Benefits']

    // 1:1 COACHING
    export const CoachingTitle = "Work 1 on 1? Sell coaching"
    export const CoachingDescription = "Provide personalized 1:1 asynchronous coaching to your users. Set your price, highlight the benefits, and start delivering even greater value to your audience. Enhance their experience and foster deeper connections by offering tailored support and guidance."
    export const CoachingKeypoints = ['Set Your Own Price', 'Record Video & Audio', 'Member Applications Option']

    // PAID MESSAGES
    export const PaidMessagesTitle = "Provide value in DMs? Sell messages"
    export const PaidMessagesDescription = "Paid messages is ideal for creators and experts who receive high volumes of inquiries and want to prioritize more serious engagements. By setting a fee for messaging, you not only filter your interactions to those who truly value your expertize and time but also create an additional monetization opportunity. "
    export const PaidMessagesKeypoints = ['Be Paid More for your Time', 'Easy to Use Messages', 'Supports Multimedia Messaging',]

    // PREMIUM COMMUNITIES
    export const PremiumCommunitiesTitle = "Premium communities? Sell access"
    export const PremiumCommunitiesDescription = "Build an exclusive space where your users can connect, share, and grow together. By establishing a premium community, you provide a unique environment that fosters deeper interaction and engagement among members."
    export const PremiumCommunitiesKeypoints = ['Engage with your Community', 'Control Access', 'Create a Premium Space']

      // ONE OFF PAYMENTS
      export const OneOffPaymentsTitle = "Create products? Sell one off products"
      export const OneOffPaymentsDescription = "Offer your customers the flexibility to make single purchases with no ongoing commitment. This model is perfect for exclusive products, special editions, or introductory offers. "
      export const OneOffPaymentsKeypoints = ['Sell One Off Products', 'Multiple Pricing Options', 'Easy Checkout']

      
// TOOLS

// CREATE
//  MULTIPLE CONTENT TYPES, COLLECTIONS, COMMUNITY, CUSTOM BRANDING

// MONETISE
//  MEMBERSHIPS, 1:1 COACHING, PAID MESSAGES, TIPPING, INSTANT PAYOUTS, ONE OFF PAYMENTS

// GROWTH
// VIRAL LINK, REFER & EARN, SPOONSOR HUB, MEMBER REFERRALS, PAID MEDIA

export const ToolsHeader = "Tools to help you grow, monetize and scale your hub"
export const ToolsDescription = "Empower your creativity with tools that enhance content production and deliver exceptional value to your members. Craft, brand, and connect effortlessly."

export const CreateHeader = "WE MAKE CREATING EASY."
export const CreateDescription = "Empower your creativity with tools that enhance content production and deliver exceptional value to your members. Craft, brand, and connect effortlessly."
export const CreateTools = ['Multiple Content Types', 'Collections', 'Community', 'Custom Branding']

export const MonetiseHeader = "MONETIZING MADE SIMPLE."
export const MonetiseDescription = "Leverage our monetization tools to effortlessly convert your creativity into earnings. Utilize memberships, coaching, paid messages and more tools to grow your income."
export const MonetiseTools = ['Memberships', '1:1 Coaching', 'Paid Messages', 'Tipping', 'Instant Payouts', 'One Off Payments']

export const GrowthHeader = "BUILT TO SCALE."
export const GrowthDescription = "Accelerate your community growth with tools that enhance member acquisition and engagement, ensuring your hub scales seamlessly."
export const GrowthTools = ['Viral Link', 'Refer & Earn', 'Sponsor Hub', 'Member Referrals', 'Paid Media', 'Affiliates']




export const SuccessHeader = "Here’s what our awesome partners say about WithMe."

export const PricingPageDescription = "No obligations, no contracts, cancel at any time."
export const PricingPageDescriptionB = "£25/month. No hidden fees. No upsells. No stress. Cancel anytime. Switch to annual and save 20%."





